import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useTutorKanbanStore } from './store'
import { useTutorKanbanSave } from './tutor-kanban-save.hook'

interface TutorKanbanFinalDayConfirmReturn {
  isConfirmOpen: ComputedRef<boolean>
  setConfirmChange: () => Promise<void>
  setCancelChange: () => void
}

export const useTutorKanbanFinalDayConfirm = (): TutorKanbanFinalDayConfirmReturn => {
  const tutorKanbanStore = useTutorKanbanStore()
  const { setSubmitFinalDayConfirmed } = useTutorKanbanSave()

  const isConfirmOpen = computed<boolean>(() => tutorKanbanStore.isFinalDayConfirmOpen)

  const setConfirmChange = async (): Promise<void> => {
    tutorKanbanStore.setFinalDayConfirmOpen(false)
    await setSubmitFinalDayConfirmed()
  }

  const setCancelChange = (): void => {
    tutorKanbanStore.setFinalDayConfirmOpen(false)
  }

  return {
    isConfirmOpen,
    setConfirmChange,
    setCancelChange,
  }
}
